function getFilterContainer(el) {
  return el.closest('facet-dialog') || el.closest('.checkbox-list');
}

// Recherche en temps réel (horizontal + vertical)
document.addEventListener('input', function (e) {
  const input = e.target;
  if (!input.classList.contains('facet-inline-search__input')) return;

  const container = getFilterContainer(input);
  if (!container) return;

  const query = input.value.trim().toLowerCase();
  const options = container.querySelectorAll('.facet-option-item');
  let visibleCount = 0;

  options.forEach(function (option) {
    const label = option.dataset.label || '';
    const checkbox = option.querySelector('input[type="checkbox"]');
    const isActive = checkbox && checkbox.checked;
    const matches = !query || label.includes(query);

    const shouldShow = matches || isActive;
    option.classList.toggle('is-hidden', !shouldShow);
    if (shouldShow) visibleCount++;
  });

  const emptyMsg = container.querySelector('.facet-inline-search__empty');
  if (emptyMsg) emptyMsg.hidden = visibleCount > 0;

  const countEl = container.querySelector('.facet-dialog-footer__count');
  if (countEl) countEl.textContent = visibleCount + ' modèle' + (visibleCount !== 1 ? 's' : '');
});

// Vide la recherche quand une case est cochée/décochée
document.addEventListener('change', function (e) {
  const checkbox = e.target;
  if (!checkbox.matches('.facet-option-item input[type="checkbox"]')) return;

  const container = getFilterContainer(checkbox);
  if (!container) return;

  const searchInput = container.querySelector('.facet-inline-search__input');
  if (!searchInput || !searchInput.value) return;

  searchInput.value = '';
  container.querySelectorAll('.facet-option-item').forEach(function (o) {
    o.classList.remove('is-hidden');
  });

  const emptyMsg = container.querySelector('.facet-inline-search__empty');
  if (emptyMsg) emptyMsg.hidden = true;

  const total = container.querySelectorAll('.facet-option-item').length;
  const countEl = container.querySelector('.facet-dialog-footer__count');
  if (countEl) countEl.textContent = total + ' modèle' + (total !== 1 ? 's' : '');
});

// Réinitialise la recherche à la fermeture du facet-dialog (horizontal uniquement)
document.addEventListener('dialog:after-hide', function (e) {
  const dialog = e.target;
  if (!dialog.matches('facet-dialog')) return;

  const input = dialog.querySelector('.facet-inline-search__input');
  if (!input) return;

  input.value = '';
  dialog.querySelectorAll('.facet-option-item').forEach(function (o) {
    o.classList.remove('is-hidden');
  });

  const emptyMsg = dialog.querySelector('.facet-inline-search__empty');
  if (emptyMsg) emptyMsg.hidden = true;
});
